export default __webpack_public_path__ + "static/media/contact-us-wave-xs.e0c7c805.svg";